import { useRef, useState, useEffect } from 'react';
import ButtonControl from "../../../Controls/ButtonControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import TextAreaControl from "../../../Controls/TextAreaControl"
import TextBoxNumericControl from "../../../Controls/TextBoxNumericControl"
import ButtonUploadControl from "../../../Controls/ButtonUploadControl"
import SelectControl from "../../../Controls/SelectControl"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate,useLocation } from "react-router-dom";
import ShowEngineerResidentialInfo from "../../../Controls/ShowEngineerResidentialInfo"
import DatePickerControl from "../../../Controls/DatePickerControl"

import { 
	SetLocal,
	ClearLocal,
	GetLocal,
	FetchService ,
	IsValidNationalCode,
	IsEmptyString,
	IsEmptyInput,
	GetParamsUrl,
	Base64Type,
	ConvertCharacterDate	
} from "../../../Base/BaseControl";

import { toast } from 'react-toastify';

let listFileType = '';
let listFile = '';
let MessageShowGeneralCommands = '';

export default function Index(props) {

	const navigate = useNavigate();
	const location = useLocation();
	
	const inpTypeRequestRef = useRef(null);
	const inpTypeDocumentRef = useRef(null);
	const inpDescriptionRef = useRef(null);
	
	const inpDateRef = useRef(null);
	const inpFileRef = useRef('');

	const [showModal, setShowModal] = useState(false);
	const [getSelectData, setSelectData] = useState([]);	
	const [getDocumentSelectData, setDocumentSelectData] = useState([]);
	const [getServiceResult, setServiceResult] = useState([]);

	const [getOffence, setOffence] = useState(0);	
	//const [getFile, setFile] = useState(false);
	//const [getFileType, setFileType] = useState(false);
	const [getdocumentEntityInfoVlueState, setdocumentEntityInfoVlueState] = useState([]);
	const [getShowGetFileStatus, setShowGetFileStatus] = useState('');
	
	const [getValueDocumentSelectData, setValueDocumentSelectData] = useState([]);
  
    useEffect(() => {	
		ShowGeneralCommands();	
		ShowBuildingStageByEngineerAbstractList();	
    }, []);	
	
	const ShowGeneralCommands =()=>{
        var inputValue = {
			session: GetLocal('EngineerSession'),
			identifier: 3
		};
        FetchService("Engineer/General/ShowGeneralCommands", inputValue, ShowGeneralCommandsSuccess);		
	}	
	
	const ShowGeneralCommandsSuccess =(ServiceResult)=>{
		MessageShowGeneralCommands = ServiceResult.entity.replace('\n','</br>');		
	}		

	const EngineerReportFetch =()=>{
        var inputValue = {
			session: GetLocal('EngineerSession'),
			id : location.state.ID
		};
        FetchService("Engineer/Request/EngineerReportFetch", inputValue, EngineerReportFetchSuccess);		
	}

	const EngineerReportFetchSuccess =(ServiceResult)=>{
		setServiceResult(ServiceResult);
		setOffence(ServiceResult.OffenceStatus);
		inpTypeRequestRef.current.value = ServiceResult.BuildingStageID;
		inpDescriptionRef.current.value = ServiceResult.Description;
		listFileType = ServiceResult.ExtensionFile;
		listFile = ServiceResult.Base64Content;
		//if(ServiceResult.Base64Content != '')
			//inpFileRef.current.value = true;
	}		

	const ShowBuildingStageByEngineerAbstractList =(ServiceResult)=>{
        var inputValue = {session:  GetLocal('EngineerSession')};
        FetchService("Engineer/Abstract/ShowBuildingStageByEngineerAbstractList", inputValue, ShowBuildingStageByEngineerAbstractListSuccess);		
	}
	
	const ShowBuildingStageByEngineerAbstractListSuccess =(ServiceResult)=>{
		setSelectData(ServiceResult.BuildingStageByEngineerInfo);
		if(GetParamsUrl('edit') == 1)
			EngineerReportFetch();			
		
	}		

    const SetTypeOffence = (value) => {
		setOffence(value);
    }	
	
    const CreateEngineerReport = (event) => {	
        if (IsEmptyInput(inpTypeRequestRef))
            return false;
        if (IsEmptyInput(inpDateRef))
            return false;
        if (IsEmptyInput(inpDescriptionRef))
            return false;
        if (IsEmptyInput(inpFileRef) && GetParamsUrl('edit') != 1)
            return false;		

        var inputValue = {
			session:  GetLocal('EngineerSession'),
			id: GetParamsUrl('edit')==1 ? location.state.ID:0,
			fileNumber: GetLocal('FileNumber'),
			buildingStageID: inpTypeRequestRef.current.value,
			createdOn: ConvertCharacterDate(inpDateRef.current.firstChild.defaultValue),
			offenceStatus: getOffence==1?true:false,
			description: inpDescriptionRef.current.value,
			extensionFile: listFileType,
			uploadedFile: listFile			
        };
		
        FetchService("Engineer/Request/CreateEngineerReport", inputValue, CreateEngineerReportSuccess);			
    }	
	
	const CreateEngineerReportSuccess =(ServiceResult)=>{
		toast.success("اطلاعات با موفقیت ثبت گردید");
		if(GetParamsUrl('edit') == 1)
			navigate("/Engineer/ShowReportsList?page=گزارش ها");
		else
			navigate("/Engineer/GetEngineerFileList?page=نمایش لیست پرونده ها");
	}

	const onChangeFile =(type,value)=>{
		listFileType = type;
		listFile = value;
	}	

	const DownalodFile = (ServiceResult)=>{
		var a = document.createElement("a");
		a.href = Base64Type(ServiceResult.ExtensionFile) + ServiceResult.Base64Content;
		a.download = Math.floor(Math.random() * 10000)+"."+ ServiceResult.ExtensionFile;
		a.click();	
		a.remove();		
	}		

    return (
        <div>
				<ShowEngineerResidentialInfo/>
				<div className="p-5 pt-0">
					<div className="col-sm-6">
						<SelectControl 
							data={getSelectData}
							required={true}
							title="مرحله: "
							inputRef={inpTypeRequestRef}
						/>
						<br/>		
						<DatePickerControl
							title="تاریخ:"
							required={true}
							value="1403/02/04"
							value={getServiceResult.CreatedOn}
							inputRef={inpDateRef}
						/>
						<br/>	
						<div>
						وضعیت خلاف: &nbsp;&nbsp;&nbsp;
							<input onClick={()=>SetTypeOffence(0)} checked={getOffence == 0} type="radio" value="0" id="0" name="Offence" /> خلاف ندارد &nbsp;&nbsp;
							<input onClick={()=>SetTypeOffence(1)} checked={getOffence == 1} type="radio" value="1" id="1" name="Offence" /> خلاف دارد  
						</div>	
						<br/>	
					</div>	
					<div className="col-sm-6">	
                        <TextAreaControl
                            title="توضیحات:"
							required={true}
							inputRef={inpDescriptionRef}
                        /><br/>	
						
						<p className="text-danger" dangerouslySetInnerHTML={{__html: MessageShowGeneralCommands}}></p>
						
						{GetParamsUrl('edit') == 1 && <p class="text-primary" onClick={()=>DownalodFile(getServiceResult)}>» دانلود فایل</p>}
						<ButtonUploadControl
							title="پیوست درخواست:"
							required={true}
							inputRef={inpFileRef}
							className="w-100"
							size="35000"
							onChangeFile={onChangeFile}
							fileType={/.pdf|.ttf|.jpg|.tiff|.tif|.bmp|.jpeg/}
							accept=".pdf, .ttf, .jpg, .tiff, .tif, .bmp, .jpeg"
						/>							
					</div>
					<br/>
					<br/>	
					<ButtonControl 
						onClick={()=>CreateEngineerReport()} 
						variant="success"
						title={GetParamsUrl('edit')==1 ?'ویرایش':'ذخیره'}
						icon="fa fa-plus"
					/>	
					<ButtonControl 
						onClick={()=>window.history.back()} 
						variant="danger"
						className="mx-4"
						title="انصراف"
						icon="fa fa-remove"
					/>					
				</div>	
        </div>
    );
}
